import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermission } from '../contexts/PermissionContext';

const EXEMPT_PATHS = [
  '/dashboard',
  '/dashboard/view',
  '/dashboard-procurement',
  '/index',
  '/profile',
  '/',
];

const isExemptPath = pathname =>
  EXEMPT_PATHS.some(
    exempt => pathname === exempt || pathname.startsWith(`${exempt}/`)
  );

const ProtectedRoute = ({ children }) => {
  const { user } = useSelector(state => state.Login);
  const location = useLocation();
  const { isMenuLoading, can } = usePermission();
  const pathname = location.pathname;

  if (!user) {
    return <Navigate to='/login' />;
  }

  if (isMenuLoading) {
    return (
      <div className='d-flex justify-content-center align-items-center min-vh-100'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }

  if (isExemptPath(pathname)) {
    return children;
  }

  if (!can('canRead', pathname)) {
    return <Navigate to='/pagenotfound' />;
  }

  return children;
};

export default ProtectedRoute;
